import Cookie from 'js-cookie';
import AppConfig from './domain/AppConfig';
import { BrowserUtil } from './BrowserUtil';
import { getEnvironment } from './AppConfigUtil';
export const aperzaJpSubdomains = [
    AppConfig.APERZA_SEARCH,
    AppConfig.APERZA_NEWS,
    AppConfig.APERZA_ID,
    AppConfig.APERZA_ACCOUNT,
];
export const aperzaJpSubdomain = {
    www: {
        serviceType: AppConfig.APERZA_SEARCH,
    },
    ec: {
        serviceType: AppConfig.APERZA_EC,
    },
    news: {
        serviceType: AppConfig.APERZA_NEWS,
    },
    id: {
        serviceType: AppConfig.APERZA_ID,
    },
    account: {
        serviceType: AppConfig.APERZA_ACCOUNT,
    },
    order: {
        serviceType: AppConfig.APERZA_ORDER,
    },
    business: {
        serviceType: AppConfig.APERZA_BIZ,
    },
};
// const aperzaComSubdomains = [
//   AppConfig.APERZA_ORDER,
//   AppConfig.APERZA_BIZ,
// ];
export const aperzaComSubdomain = {
    www: {
        serviceType: AppConfig.APERZA_SEARCH,
    },
    ec: {
        serviceType: AppConfig.APERZA_EC,
    },
    order: {
        serviceType: AppConfig.APERZA_ORDER,
    },
    business: {
        serviceType: AppConfig.APERZA_BIZ,
    },
    id: {
        serviceType: AppConfig.APERZA_ID,
    },
    account: {
        serviceType: AppConfig.APERZA_ACCOUNT,
    },
    catalog: {
        serviceType: AppConfig.APERZA_CATALOG,
    },
    tv: {
        serviceType: AppConfig.APERZA_TV,
    },
};
export const aperzaCatalogPathPrefixes = [
    '/catalog',
    '/modal',
    '/company',
    '/product',
    '/feature',
    '/download',
    '/trends',
    '/search',
    '/aboutus',
];
export const getDomain = () => {
    return BrowserUtil.getHost();
};
export const getPath = () => {
    return BrowserUtil.getPath();
};
export const getHref = () => {
    return BrowserUtil.getHref();
};
export const getServiceType = () => {
    const domain = getDomain();
    const path = getPath();
    const href = getHref();
    if (domain) {
        if (domain.endsWith('.aperza.jp')) {
            // eslint-disable-next-line no-restricted-syntax
            for (const subdomain in aperzaJpSubdomain) {
                if (domain.startsWith(subdomain)) {
                    const domainObject = aperzaJpSubdomain[subdomain];
                    return domainObject.serviceType;
                }
            }
        }
        else if (domain.endsWith('.aperza.com')) {
            if (domain.startsWith('www')) {
                if (path.startsWith('/catalog') ||
                    path.startsWith('/catalog/') ||
                    path.startsWith('/feature/') ||
                    path.startsWith('/feature2/') ||
                    path.startsWith('/company/') ||
                    path.startsWith('/trends/') ||
                    path.startsWith('/download/') ||
                    path.startsWith('/product/') ||
                    path.startsWith('/aboutus/')) {
                    return aperzaComSubdomain.catalog.serviceType;
                }
                return aperzaComSubdomain.www.serviceType;
            }
            if (domain.startsWith('ec')) {
                return aperzaComSubdomain.ec.serviceType;
            }
            if (domain.startsWith('order')) {
                return aperzaComSubdomain.order.serviceType;
            }
            if (domain.startsWith('business')) {
                return aperzaComSubdomain.business.serviceType;
            }
            if (domain.startsWith('id')) {
                return aperzaComSubdomain.id.serviceType;
            }
            if (domain.startsWith('account')) {
                return aperzaComSubdomain.account.serviceType;
            }
            if (domain.startsWith('tv')) {
                return aperzaComSubdomain.tv.serviceType;
            }
            // for (const subdomain in aperzaComSubdomain) {
            //   if (domain.startsWith(subdomain)) {
            //     return aperzaComSubdomain[subdomain].serviceType;
            //   }
            // }
        }
        else if (href.includes('neca.') || href.includes('neca-')) {
            return AppConfig.APERZA_NECA;
        }
    }
    return undefined;
};
export const isAperzaAccountDomain = () => {
    return getServiceType() === AppConfig.APERZA_ACCOUNT;
};
export const isAperzaIdDomain = () => {
    return getServiceType() === AppConfig.APERZA_ID;
};
export const isAperzaOrderDomain = () => {
    return getServiceType() === AppConfig.APERZA_ORDER;
};
export const isAperzaBusinessDomain = () => {
    return getServiceType() === AppConfig.APERZA_BIZ;
};
export const isAperzaNewsDomain = () => {
    return getServiceType() === AppConfig.APERZA_NEWS;
};
export const isAperzaSearch = () => {
    return getServiceType() === AppConfig.APERZA_SEARCH;
};
export const isAperzaCatalog = () => {
    if (getServiceType() === AppConfig.APERZA_SEARCH) {
        const domain = getDomain();
        const path = getPath();
        for (const pathPrefix of aperzaCatalogPathPrefixes) {
            if (path.startsWith(pathPrefix) || path.startsWith(`/en${pathPrefix}`)) {
                return true;
            }
        }
    }
    return false;
};
export const isAperzaCatalogTop = () => {
    if (isAperzaCatalog()) {
        const path = getPath();
        if (path) {
            return (path.endsWith('/catalog/index.html') ||
                path.endsWith('/catalog') ||
                path.endsWith('/catalog/') ||
                path.endsWith('/en/catalog/') ||
                path.endsWith('/en/catalog/'));
        }
    }
    return false;
};
export const isOrderCheckout = () => {
    if (isAperzaOrderDomain()) {
        const path = getPath();
        if (path) {
            return (path.startsWith('/checkout/confirm') ||
                path.startsWith('/checkout/shipping') ||
                path.startsWith('/checkout/payment') ||
                path.startsWith('/checkout/invoice'));
        }
    }
    return false;
};
export const isOrderRegister = () => {
    if (isAperzaOrderDomain()) {
        const path = getPath();
        if (path) {
            return ((path.startsWith('/register') || path.startsWith('/member')) &&
                !path.endsWith('completed.html'));
        }
    }
    return false;
};
export const isBusinessSignup = () => {
    if (isAperzaBusinessDomain()) {
        const path = getPath();
        if (path) {
            return path.indexOf('/signup/') !== -1;
        }
    }
    return false;
};
export const isBusinessOrders = () => {
    if (isAperzaBusinessDomain()) {
        const path = getPath();
        if (path) {
            return path.indexOf('/f/order') !== -1;
        }
    }
    return false;
};
export const isAperzaMarketplace = () => {
    if (getServiceType() === AppConfig.APERZA_EC) {
        const domain = getDomain();
        return domain.startsWith('ec.');
    }
    return false;
};
export const isAperzaTv = () => {
    if (getServiceType() === AppConfig.APERZA_TV) {
        const domain = getDomain();
        return domain.startsWith('tv.');
    }
    return false;
};
// TODO to be merge with the same method in AppService
export const isMainPage = () => {
    const pathName = BrowserUtil.getPath();
    return (pathName === '/' ||
        pathName === '/en' ||
        pathName === '/en/' ||
        pathName.startsWith('/en/?') ||
        pathName === '/ja' ||
        pathName === '/ja/' ||
        pathName.startsWith('/ja/?'));
};
export const isAperzaSearchResultPage = () => {
    if (getServiceType() === AppConfig.APERZA_SEARCH) {
        const path = getPath();
        if (path.includes('/s/model') || path.includes('/s/catalog') || path.includes('/s/item')) {
            return true;
        }
    }
    return false;
};
export const isAperzaSearchCatalogResultPage = () => {
    if (getServiceType() === AppConfig.APERZA_SEARCH) {
        const path = getPath();
        if (path.includes('/s/catalog')) {
            return true;
        }
    }
    return false;
};
export const isAperzaCompanyPage = () => {
    if (getServiceType() === AppConfig.APERZA_SEARCH) {
        const path = getPath();
        if (path.includes('/new_catalog/page') ||
            path.match(/\/co\/([0-9].*)/) ||
            path.match(/\/co\/([a-z1-9].*)\/catalog\/([1-9-].*)/)) {
            return true;
        }
    }
    return false;
};
export const isAperzaSearchItemResultPage = () => {
    if (getServiceType() === AppConfig.APERZA_SEARCH) {
        const path = getPath();
        if (path.includes('/s/item')) {
            return true;
        }
    }
    return false;
};
export const isAperzaSearchNewsResultPage = () => {
    if (getServiceType() === AppConfig.APERZA_SEARCH) {
        const path = getPath();
        if (path.includes('/s/news')) {
            return true;
        }
    }
    return false;
};
export const shouldShowMarketplaceTopBanner = () => {
    const domain = getDomain();
    const path = getPath();
    return (path.startsWith('/marketplace/index.html') ||
        path.endsWith('/marketplace/') ||
        (domain.startsWith('ec.') && path.endsWith('/')) ||
        (domain.startsWith('ec.') && path.endsWith('/en/')) ||
        (domain.startsWith('ec.') && path.endsWith('/en')) ||
        (domain.startsWith('ec.') && path.includes('/error-search/')) ||
        path.startsWith('/marketplace/event/') ||
        path.includes('/dst/mp/') ||
        path.includes('/d/i/') ||
        path.includes('/s/item/') ||
        path.endsWith('/mfr/index.html'));
};
export const getLangKey = (env = getEnvironment()) => {
    const key = 'al';
    if (env && env.length > 0) {
        return `${env}${key}`;
    }
    return key;
};
export const getLangCode = (env = getEnvironment()) => {
    if (isAperzaIdDomain() || isAperzaAccountDomain() || isAperzaOrderDomain()) {
        // only japanese language
        return 'ja';
    }
    if (isAperzaCatalog()) {
        if (getPath().startsWith('/en')) {
            return 'en';
        }
        return 'ja';
    }
    // APERZA.locale is generated by search-web
    let langCode = 'ja';
    if (BrowserUtil.isBrowser() && window.APERZA && window.APERZA.locale) {
        langCode = window.APERZA.locale; // TODO test this used to be APERZA.locale
    }
    else {
        const key = getLangKey(env);
        langCode = Cookie.get(key);
    }
    if (langCode) {
        return langCode;
    }
    return 'ja';
};
